__webpack_require__.p = "/tabuk_study/";